<template>
    <div class="recharge-feedback-help-dialog">
          <!-- 吸底提示条（只在折叠状态显示） -->
        <div class="recharge-feedback-help-dialog-bottom" v-if="!isExpanded && dialogDismissed" @click="openExpanded">
          <div class="left">
            <img :src="feedbackIcon" class="rechargeIcon" />
            <span class="label">{{ $t('m.feedback_and_help') }}</span>
          </div>
          <img :src="closeIcon" class="closeIcon"  @click.stop="dismissSecondPaymentDialog" />
        </div>
        <!-- 反馈详情弹框（只在打开状态显示） -->
        <transition name="modal-slide">
          <div v-if="isExpanded" class="rfhd-modal-overlay" @click.self="closeExpanded(false)">
            <div class="rfhd-modal">
              <div class="rfhd-modal-header">
                <div class="rfhd-modal-title-wrap">
                  <div class="rfhd-modal-title">{{ $t('m.feedback_and_help') }}</div>
                </div>
                <img :src="modalCloseIcon" class="rfhd-modal-close" @click.stop="closeExpanded(false)"  />
              </div>
              <div class="rfhd-modal-body">
                <div class="rfhd-intro">
                  <img  src="@/assets/img/logo.png" class="rfhd-intro-icon" alt="icon" />
                  <div class="rfhd-intro-text">
                    {{ $t('m.try_recharge_methods', { feedback: $t('m.feedback') }) }}
                  </div>
              </div>
              <div class="rfhd-recommend-title">{{ $t('m.recommended_recharge_methods') }}</div>

              <div class="payment-scroll-container" v-if="paymentMethodsLocal && paymentMethodsLocal.length">
                <van-collapse :value="activePayIndex" accordion class="payStyleCon" @input="setActivePayIndex">
                  <!-- 币商单独显示 -->
                  <van-collapse-item :name="'trader'" v-if="traderOption" :key="'pay-trader'">
                    <template #title>
                      <div class="fc-flex fc-flex-vcenter" @click="onTraderTitleClick">
                        <span class="payStyleIcon">
                          <img :src="(traderOption.rechargePayType && traderOption.rechargePayType.payTypeImg) || '@/assets/img/logo.png'" :alt="(traderOption.rechargePayType && traderOption.rechargePayType.payTypeShowName) || '币商'">
                        </span>
                        <span class="fc-flex1 fc-text-bigabit">{{ (traderOption.rechargePayType && traderOption.rechargePayType.payTypeShowName) || traderOption.name || '币商' }}</span>
                      </div>
                    </template>
                    <div class="payTiptxt" v-if="traderOption.rechargePayType && traderOption.rechargePayType.payTypeShowName && traderOption.rechargePayType.payTypeShowName.toLowerCase() == 'razer gold pin'"> {{ $t('m.recharge_tip') }}</div>

                    <!-- 币商列表内容 -->
                    <div v-if="sellerList.length > 0" class="sellers-content">
                      <div class="seller-item" v-for="(item, index) in sellerList" :key="index">
                        <div class="seller-item-head">
                          <div class="fc-relative">
                            <img class="seller-photo" :src="item.img">
                            <img class="seller-flag" :src="item.logo">
                      </div>
                          <div class="seller-info">
                            <div class="seller-title-id">
                              <span class="seller-title fc-elip-2">{{ item.nickname }}</span>
                              <div class="seller-ids">
                                <span class="seller-id">ID:{{ item.userId }}</span>
                                <img class="copy-btn" src="@/assets/img/copy.png" @click="copySellerId($event, item.userId)">
                      </div>
                    </div>
                            <div class="seller-balance">
                              <span class="balance-title fc-elip-1">{{ $t('m.buy_balance') }}</span>
                              <img class="balance-icon" src="@/assets/img/diamond.png">
                              <span class="balance-num">{{ item.diamond }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="seller-paytypes">
                          <div class="paytypes-list">
                            <div class="paytype-box" v-for="(pay, i) in item.payTypes">
                              <img :src="pay.payTypeImg">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- 币商无数据状态 -->
                    <div v-if="sellerList.length < 1 && userInfo.userId" class="sellers-nodata">
                      <img src="@/assets/img/nodata.png" alt="">
                    </div>

                    <!-- 币商未登录状态 -->
                    <div v-if="sellerList.length < 1 && !userInfo.userId" class="sellers-no-login">
                      <div class="no-login-content">
                        <img src="@/assets/img/noLogin.png" alt="">
                        <p class="login-tip">{{ $t('m.login_after_recharge') }}</p>
                      </div>
                      <div class="fc-btn-line-login" @click="$router.push('/login')">{{ $t('m.login') }}</div>
                    </div>

                    <!-- 币商列表组件 -->
                    <van-list v-if="showSellersList" v-model="sellersLoading" loading-text="加载中..." :finished="sellersFinished" finished-text="" @load="getSellerList" class="sellers-list-hidden">
                      <!-- 隐藏的列表内容，仅用于触发加载 -->
                    </van-list>
                  </van-collapse-item>
                  <!-- 其他支付方式 -->
                  <van-collapse-item :name="index" v-for="(item, index) in otherPaymentMethods" :key="'pay' + index" v-if="item.rechargePayType && !item.isTrader">
                    <template #title>
                      <div class="fc-flex fc-flex-vcenter">
                        <span class="payStyleIcon">
                          <img :src="item.rechargePayType.payTypeImg || '@/assets/img/logo.png'" :alt="item.rechargePayType.payTypeShowName || 'Payment'">
                        </span>
                        <span class="fc-flex1 fc-text-bigabit">{{ item.rechargePayType.payTypeShowName || item.payTypeName || 'Payment Method' }}</span>
                      </div>
                    </template>
                    <div class="payTiptxt" v-if="item.rechargePayType.payTypeShowName && item.rechargePayType.payTypeShowName.toLowerCase() == 'razer gold pin'"> {{ $t('m.recharge_tip') }}</div>
                    <div class="buyInfoItem" v-for="(son, sonIndex) in (item.rechargeNormList || [])" :key="'paymoney' + sonIndex" v-if="son">
                      <img class="diamond_icon" src="@/assets/img/diamond.png" alt="diamond">
                      <div class="fc-flex fc-flex-vcenter fc-flex1">
                        <span class="buyNum">{{ son.newNumber || son.number || 0 }}</span>
                        <span class="morereward_txt" v-if="(son.awardNumber || 0) > 0">+{{ son.awardNumber || 0 }}</span>
                        <img class="morereward_img" :src="son.img" v-if="son.img && son.isActivity" alt="activity">
                      </div>
                      <div class="fc-btn-line-main payBtn" @click="handleRechargeClick(item, son)">
                        {{ calLocalMoney(son) }}
                      </div>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
              <div v-else class="nodataImg">
                <img src="@/assets/img/nodata.png" alt="no data">
              </div>
            </div>
            <div class="rfhd-modal-footer">
              <button class="rfhd-feedback-btn" @click="onFeedback">{{ $t('m.feedback') }}</button>
            </div>
          </div>
          </div>
        </transition>
    </div>
</template>
<script>

    // 导入vue-store 
    import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
    import { Collapse, CollapseItem, Dialog, Toast, List } from 'vant';
    import Clipboard from 'clipboard';
    import Vue from 'vue';
    import { createOrderAjax, pagSmileCreateOrderAjax, payssionCreateOrderAjax, dlocalCreateOrderAjax, dukPayCreateOrderAjax, codaPayCreateOrderAjax, paymentWallPaypalCreateOrder, gotoFeedbackFromPay, clickCardMerchant } from "@/api/pay.js";
    import { exitLogin } from "@/tools/common.js";
    import { getDomainCountryFiled } from "../util";
    import feedbackIcon from '@/assets/img/feedback.svg';
    import closeImg from '@/assets/img/login_top_icon03.png';
    import modalCloseImg from '@/assets/img/cz_more.png';
    import { loadingWebp } from '../assets/img/loading';
    
    // 注册vant组件
    Vue.use(Collapse);
    Vue.use(CollapseItem);
    Vue.use(Dialog);
    Vue.use(List);
    export default {
        name: 'RechargeFeedbackHelpDialog',
    data() {
        return {
                feedbackIcon,
                closeIcon: closeImg,
                modalCloseIcon: modalCloseImg,
                payTypeArr: {
                    0:'非三方聚合',
                    1:'payerMax',
                    2:'paymentWall',
                    3:'RazerGlobal',
                    4:'dpay',
                    5:'币商',
                    6:'pagSmile',
                    7:'payssion',
                    8:'dlocal',
                    9:'Dukpay',
                    10:'CodaPay',
                    11:'paymentwall-PayPal',
                },
                // 币商相关数据
                sellerList: [],
                sellersPage: 1,
                sellersLoading: false,
                sellersFinished: false,
                showSellersList: false,
                sellersPreloaded: false,
                userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
                // 与首页保持一致的参数
                domainCountry: getDomainCountryFiled(),
                from: null,
            }
    },
    mounted() {
      // 测试currentCountry是否能正确从store获取
      console.log('[RechargeFeedbackHelpDialog] currentCountry from store:', this.currentCountry);
      // 调试paymentMethodsLocal数据
      console.log('[RechargeFeedbackHelpDialog] paymentMethodsLocal:', this.paymentMethodsLocal);
      // 初始化 from 参数，与首页保持一致
      const queryFrom = this.$route && this.$route.query && this.$route.query.from;
      this.from = queryFrom || 'feedback';
      console.log('[RechargeFeedbackHelpDialog] from:', this.from);
    },
    watch: {
      paymentMethodsLocal: {
        handler(newVal) {
          console.log('[RechargeFeedbackHelpDialog] paymentMethodsLocal changed:', newVal);
          console.log('[RechargeFeedbackHelpDialog] paymentMethodsLocal length:', newVal && newVal.length);
        },
        immediate: true,
        deep: true
      },
      // 监听弹窗展开状态
      isExpanded: {
        handler(newVal) {
          // 弹窗打开时重置币商列表状态和支付方式折叠状态
          if (newVal) {
            this.resetSellersData();
            // 预加载币商数据，避免打开币商时才去请求
            if (!this.sellersPreloaded) {
              this.getSellerList();
              this.sellersPreloaded = true;
            }
          }
        },
        immediate: false
      }
    },
    methods: {
      // 设置 activePayIndex 到 Vuex，同时处理币商展开逻辑
      setActivePayIndex(val) {
        this.$store.commit('rechargeIntercept/SET_ACTIVE_PAY_INDEX', val);
        if (val === 'trader' && !this.showSellersList) {
          this.showSellersList = true;
          this.getSellerList();
        }
      },
      openExpanded() {
        // 调用 namespaced action 打开展开状态（同时 fetch 数据）
        this.$store.dispatch('rechargeIntercept/openExpanded');
      },
      closeExpanded(dismiss = false) {
        this.$store.dispatch('rechargeIntercept/closeExpanded', dismiss);
      },
      dismissSecondPaymentDialog() {
        // 关闭二次支付弹窗，进入关闭状态
        this.$store.dispatch('rechargeIntercept/dismissSecondPaymentDialog');
      },
      onFeedback() {
        // 关闭二次支付弹窗并重置相关状态，然后跳转到问题反馈页面
        // 先获取订单号（关闭弹窗后会清除）
        const orderNo = localStorage.getItem('no');
        // 从 store 获取用户邮箱
        const userEmail = this.$store.getters['rechargeIntercept/userEmail'];
        this.$store.dispatch('rechargeIntercept/closeSecondPaymentDialogWithReset');
        gotoFeedbackFromPay(orderNo, userEmail);
      },
      // 支付方式切换埋点
      // 处理充值点击
      async handleRechargeClick(payType, normInfo) {
        console.log('充值点击:', payType, normInfo);

        // 检查用户是否登录
        const userInfo = localStorage.getItem('userInfo');
        if (!userInfo) {
          console.log('用户未登录');
          exitLogin();
          return;
        }

        try {
          const userInfoObj = JSON.parse(userInfo);
          if (!userInfoObj.token) {
            console.log('用户token不存在');
            exitLogin();
            return;
          }

          // 显示确认支付弹窗
          const price = this.calLocalMoney(normInfo);
          await new Promise((resolve, reject) => {
            Dialog.confirm({
              message: `确定要支付 ${price} 购买 ${normInfo.newNumber || normInfo.number || 0} 钻石吗？`
            }).then(() => {
              resolve();
            }).catch(() => {
              reject();
            });
          });

          // 用户确认支付，完全关闭弹窗，进入关闭状态
          this.closeExpanded(true);
          this.payforMoney(payType.rechargePayType, normInfo, userInfoObj);
        } catch (error) {
          // 用户取消了支付
          console.log('用户取消支付');
        }
      },
      // 计算本地货币显示（简化版本）
      calLocalMoney(normInfo) {
        if (!normInfo) return '$0';
        // 这里可以根据国家信息显示不同的货币格式
        // 暂时只显示美元
        return '$' + (normInfo.price_America || normInfo.price || 0);
      },

      // 重置币商数据
      resetSellersData() {
        this.sellerList = [];
        this.sellersPage = 1;
        this.sellersLoading = false;
        this.sellersFinished = false;
        this.showSellersList = false;
        this.sellersPreloaded = false;
      },

      // 获取币商列表
      getSellerList() {
        this.sellersLoading = true;
        this.$axios({
          method: 'POST',
          headers: {
            "Content-Type": 'application/json',
          },
          data: JSON.stringify({
            "page": this.sellersPage,
            "size": 10,
            "userId": this.userInfo.userId || null,
          }),
          url: process.env.weiApiUrl + '/api/h5/trade/account/coinAccountListPage',
        }).then(({ data }) => {
          this.sellersLoading = false;
          console.log('获取币商列表:', data);
          if (data.code == 1) {
            if (this.sellersPage < 2) {
              if (data.data.list.length < 1) {
                this.sellersFinished = true;
              } else {
                this.sellerList = data.data.list;
                this.sellersPage++;
              }
            } else {
              if (data.data.list.length < 1) {
                this.sellersFinished = true;
              }
              this.sellerList = this.sellerList.concat(data.data.list);
              this.sellersPage++;
            }
          } else {
            this.sellersLoading = false;
            this.sellersFinished = true;
          }
        }).catch(e => {
          this.sellersLoading = false;
          this.sellersFinished = true;
          console.error('获取币商列表失败:', e);
        });
      },

      // 点击币商标题
      onTraderTitleClick() {
        console.log('点击了币商标题');
        // 调用点击了卡片中的币商接口
        const no = localStorage.getItem('no') || '';
        clickCardMerchant({ no }).then(({ data }) => {
          console.log('点击币商标题接口响应:', data);
        }).catch(e => {
          console.error('点击币商标题接口失败:', e);
        });
      },

      // 复制币商ID
      copySellerId(e, text) {
        console.log('复制币商ID:', e.target, text);
        const clipboard = new Clipboard(e.target, {
          text: () => String(text),
        });
        clipboard.on('success', e => {
          Toast(this.$t('m.copied'));
          clipboard.off('error');
          clipboard.off('success');
          clipboard.destroy();
        });
        clipboard.on('error', e => {
          Toast('复制失败');
          clipboard.off('error');
          clipboard.off('success');
          clipboard.destroy();
        });
      },

      // 常规支付方式下单
      createOrderPay(payPlatformId, rechargeId, aggregatePay) {
        console.log('创建订单:', payPlatformId, rechargeId, aggregatePay);

        if (payPlatformId == 2) {
          localStorage.setItem("IsWeChatPay", 'true');
        } else {
          localStorage.setItem("IsWeChatPay", 'false');
        }

        this.confirmPay(payPlatformId, rechargeId, aggregatePay);
      },

      // 确认支付
      confirmPay(payPlatformId, rechargeId, aggregatePay) {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));

        Toast.loading({
          duration: 0,
          forbidClick: true,
          icon: require("../assets/img/loading.gif"),
          className: 'loading'
        });

        let newWindow = null;
        if (payPlatformId == 3 || payPlatformId == 10075 || payPlatformId === 10076 || payPlatformId === 10078) {
          const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (isSafari) {
            const loadingHtml = `
              <!DOCTYPE html>
              <html>
              <head>
                <title>Redirecting to payment...</title>
              </head>
              <body>
              </body>
              </html>
            `;
            newWindow = window.open(`data:text/html;base64,${btoa(loadingHtml)}`, '_blank');
          } else {
            newWindow = window.open('', '_blank');
            newWindow.document.body.innerHTML = `
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <img style="width: 140px; height: 60px;" src="${loadingWebp.base64}" alt="">
              </div>
            `;
          }
          newWindow.document.title = 'Redirecting to payment...';
        }

        // 从 Vuex store 获取选中国家信息，优先使用 store（解决移动浏览器 localStorage 隔离问题）
        const selCountryInfo = this.selCountryInfo || {};

        // 构建下单参数：与首页保持一致
        const param = {
          systoken: userInfo.token,
          userId: userInfo.userId,
          rechargeId: rechargeId,
          countryCode: selCountryInfo.coding,
          domainCountry: this.domainCountry,
          from: this.from,
          bindNo: localStorage.getItem('no') || '',
          feedbackPosition: 4
        };

        createOrderAjax(param, payPlatformId, 1).then((res) => {
          // 如果 handleCreateOrderResult 标记为失败，阻止后续操作
          if (res && res.fail) {
            newWindow && newWindow.close();
            Toast.clear();
            return;
          }
          Toast.clear();
          if (res.data.code == 1) {
            const tradeNo = res.data.result.tradeNo;
            if (payPlatformId == 3 || payPlatformId == 10075) {
              const targetUrl = this.global_paypalUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
              newWindow.location.replace(targetUrl);
            } else if (payPlatformId === 10076) {
              const targetUrl = process.env.paypalUrl_IT + "/web/h5/pay/start?tradeNo=" + tradeNo;
              newWindow.location.replace(targetUrl);
            } else if (payPlatformId === 10078) {
              const targetUrl = process.env.paypalUrl_10078 + "/web/h5/pay/start?tradeNo=" + tradeNo;
              newWindow.location.replace(targetUrl);
            } else if (aggregatePay == 3 || aggregatePay == 4) {
              newWindow && newWindow.close();
              window.location.href = tradeNo;
            } else {
              newWindow && newWindow.close();
              window.location.href = this.global_apiUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
            }
          } else if (res.data.code == 6000) {
            newWindow && newWindow.close();
            Dialog.alert({
              message: '支付失败，系统风险过高',
              confirmButtonText: 'OK'
            });
          } else if (res.data.code == 6001) {
            newWindow && newWindow.close();
            Dialog.alert({
              message: '支付方式不可用，请选择其他方式',
              confirmButtonText: 'OK'
            });
          } else if (res.data.code == -1) {
            newWindow && newWindow.close();
            exitLogin();
          }
        }).catch((error) => {
          newWindow && newWindow.close();
          Toast(error.message || this.$t('m.pay_failed'));
        });
      },

      // pagSmile支付
      pagSmilePay(normId, payTypeId, payPage = 1) {
        Toast.loading({
          duration: 0,
          forbidClick: true,
          icon: require("../assets/img/loading.gif"),
          className: 'loading'
        });

        // 从 Vuex store 获取选中国家信息
        const selCountryInfo = this.selCountryInfo || {};

        pagSmileCreateOrderAjax({
          payTypeId: payTypeId,
          normId: normId,
          countryCode: selCountryInfo.coding,
          domainCountry: this.domainCountry,
          from: this.from,
          bindNo: localStorage.getItem('no') || '',
          feedbackPosition: 4,
          payPage: payPage
        }, payPage).then(({ data }) => {
          // 如果下单结果被标记为 fail，则阻止后续操作
          if (data && data.fail) {
            Toast.clear();
            return;
          }
          Toast.clear();
          if (data.code == 1 && data.data.payUrl) {
            window.location.href = data.data.payUrl;
          } else {
            Toast(this.$t('m.pay_failed'));
          }
        }).catch((error) => {
          Toast(error.message || this.$t('m.pay_failed'));
        });
      },

      // payssion支付
      payssionPay(normId, payTypeId, payPage = 1) {
        Toast.loading({
          duration: 0,
          forbidClick: true,
          icon: require("../assets/img/loading.gif"),
          className: 'loading'
        });

        // 从 Vuex store 获取选中国家信息
        const selCountryInfo = this.selCountryInfo || {};

        payssionCreateOrderAjax({
          payTypeId: payTypeId,
          normId: normId,
          countryId: selCountryInfo.countryId || '',
          domainCountry: this.domainCountry,
          from: this.from,
          bindNo: localStorage.getItem('no') || '',
          feedbackPosition: 4,
          payPage: payPage
        }, payPage).then(({ data }) => {
          if (data && data.fail) {
            Toast.clear();
            return;
          }
          Toast.clear();
          if (data.code == 1 && data.data.payUrl) {
            window.location.href = data.data.payUrl;
          } else {
            Toast(this.$t('m.pay_failed'));
          }
        }).catch((error) => {
          Toast(error.message || this.$t('m.pay_failed'));
        });
      },

      // dlocal支付
      dlocalPay(normId, payTypeId, payPage = 1) {
        Toast.loading({
          duration: 0,
          forbidClick: true,
          icon: require("../assets/img/loading.gif"),
          className: 'loading'
        });

        // 从 Vuex store 获取选中国家信息
        const selCountryInfo = this.selCountryInfo || {};

        dlocalCreateOrderAjax({
          payTypeId: payTypeId,
          normId: normId,
          countryId: selCountryInfo.countryId || '',
          domainCountry: this.domainCountry,
          from: this.from,
          bindNo: localStorage.getItem('no') || '',
          feedbackPosition: 4,
          payPage: payPage
        }, payPage).then(({ data }) => {
          if (data && data.fail) {
            Toast.clear();
            return;
          }
          Toast.clear();
          if (data.code == 1 && data.data.payUrl) {
            window.location.href = data.data.payUrl;
          } else {
            Toast(this.$t('m.pay_failed'));
          }
        }).catch((error) => {
          Toast(error.message || this.$t('m.pay_failed'));
        });
      },

      // dukPay支付
      dukPay(normId, payTypeId, payPage = 1) {
        Toast.loading({
          duration: 0,
          forbidClick: true,
          icon: require("../assets/img/loading.gif"),
          className: 'loading'
        });

        // 从 Vuex store 获取选中国家信息
        const selCountryInfo = this.selCountryInfo || {};

        dukPayCreateOrderAjax({
          payTypeId: payTypeId,
          normId: normId,
          countryId: selCountryInfo.countryId || '',
          domainCountry: this.domainCountry,
          from: this.from,
          bindNo: localStorage.getItem('no') || '',
          feedbackPosition: 4,
          payPage: payPage
        }, payPage).then(({ data }) => {
          if (data && data.fail) {
            Toast.clear();
            return;
          }
          Toast.clear();
          if (data.code == 1 && data.data.payUrl) {
            window.location.href = data.data.payUrl;
          } else {
            Toast(this.$t('m.pay_failed'));
          }
        }).catch((error) => {
          Toast(error.message || this.$t('m.pay_failed'));
        });
      },

      // CodaPay支付
      codaPay(normId, payTypeId, payPage = 1) {
        Toast.loading({
          duration: 0,
          forbidClick: true,
          icon: require("../assets/img/loading.gif"),
          className: 'loading'
        });

        // 从 Vuex store 获取选中国家信息
        const selCountryInfo = this.selCountryInfo || {};

        codaPayCreateOrderAjax({
          payTypeId: payTypeId,
          normId: normId,
          countryId: selCountryInfo.countryId || '',
          domainCountry: this.domainCountry,
          from: this.from,
          bindNo: localStorage.getItem('no') || '',
          feedbackPosition: 4,
          payPage: payPage
        }, payPage).then(({ data }) => {
          if (data && data.fail) {
            Toast.clear();
            return;
          }
          Toast.clear();
          if (data.code == 1 && data.data.payUrl) {
            window.location.href = data.data.payUrl + '?txn_id=' + data.data.orderNo;
          } else {
            Toast(this.$t('m.pay_failed'));
          }
        }).catch((error) => {
          Toast(error.message || this.$t('m.pay_failed'));
        });
      },

      // PaymentWall PayPal支付
      createPaymentWallPaypal(normId, payTypeId, payPage = 1) {
        Toast.loading({
          duration: 0,
          forbidClick: true,
          icon: require("../assets/img/loading.gif"),
          className: 'loading'
        });

        // 从 Vuex store 获取选中国家信息
        const selCountryInfo = this.selCountryInfo || {};

        paymentWallPaypalCreateOrder({
          payTypeId: payTypeId,
          normId: normId,
          countryId: selCountryInfo.countryId || '',
          domainCountry: this.domainCountry,
          from: this.from,
          bindNo: localStorage.getItem('no') || '',
          feedbackPosition: 4,
          payPage: payPage
        }, payPage).then(({ data }) => {
          if (data && data.fail) {
            Toast.clear();
            return;
          }
          Toast.clear();
          if (data.code === 1 && data.data.payUrl) {
            window.location.href = process.env.baseURL + "/web/h5/pay/start?tradeNo=" + data.data.orderNo;
          } else {
            Toast(this.$t('m.pay_failed'));
          }
        }).catch((error) => {
          Toast(error.message || this.$t('m.pay_failed'));
        });
      },

      // 支付流程主方法
      payforMoney(item, info, userInfoObj) {
        let payPlatformId = item.id;
        console.log('开始支付流程:', item, info);

        let price = this.calLocalMoney(info);
        let aggregatePayTxt = this.payTypeArr[item.aggregatePay] || '非三方聚合';

        // 记录充值金额到 localStorage
        localStorage.setItem('rechargeAmount', price);
        // 记录充值方式到 localStorage
        localStorage.setItem('rechargeType', item.payTypeShowName);

        // 埋点统计
        if (this.$analytics) {
          this.$analytics.logEvent('PC_pay_price_click', {
            pay_country: 'unknown', // 这里可能需要从store获取
            paystyle_name: item.payTypeShowName,
            pay_price: this.calLocalMoney(info, false),
            aggregate_pay: aggregatePayTxt
          });
        }

        // 根据不同支付方式处理
        if ((item.payTypeShowName == 'Visa & MasterCard') || (item.payTypeAgentCode == 'cc' && item.aggregatePay == 2)) {
          // 信用卡支付，跳转到输入页面
          this.$router.push({
            name: 'email',
            params: {
              userId: userInfoObj.userId,
              token: userInfoObj.token,
              selPayStyleId: payPlatformId,
              selPayStyleNormId: info.rechargeNormId,
              countryCode: 'US', // 默认美国
              from: 'feedback'
            }
          });
        } else {
          // 其他支付方式
          if (item.aggregatePay == 6) {
            this.pagSmilePay(info.rechargeId, item.id, 1);
          } else if (item.aggregatePay == 7) {
            this.payssionPay(info.rechargeId, item.id, 1);
          } else if (item.aggregatePay == 8) {
            this.dlocalPay(info.rechargeId, item.id, 1);
          } else if (item.aggregatePay == 9) {
            this.dukPay(info.rechargeId, item.id, 1);
          } else if (item.aggregatePay == 10) {
            this.codaPay(info.rechargeId, item.id, 1);
          } else if (item.aggregatePay === 11) {
            this.createPaymentWallPaypal(info.rechargeId, item.id, 1);
          } else {
            this.createOrderPay(payPlatformId, info.rechargeNormId, item.aggregatePay);
          }
        }
      },
    },
        computed: {
            ...mapState('rechargeIntercept', ['dialogDismissed', 'isExpanded', 'paymentMethodsLocal', 'selCountryInfo', 'activePayIndex']),
            ...mapGetters('rechargeIntercept', ['currentCountry']),
            // 获取币商选项
            traderOption() {
                if (!this.paymentMethodsLocal || !this.paymentMethodsLocal.length) return null;
                return this.paymentMethodsLocal.find(item => item.isTrader);
            },
            // 获取除币商外的其他支付方式
            otherPaymentMethods() {
                if (!this.paymentMethodsLocal || !this.paymentMethodsLocal.length) return [];
                return this.paymentMethodsLocal.filter(item => !item.isTrader);
            },
            // 调试计算属性
            debugPaymentMethods() {
                console.log('[RechargeFeedbackHelpDialog] paymentMethodsLocal computed:', this.paymentMethodsLocal);
                console.log('[RechargeFeedbackHelpDialog] paymentMethodsLocal length:', this.paymentMethodsLocal && this.paymentMethodsLocal.length);
                if (this.paymentMethodsLocal && this.paymentMethodsLocal.length > 0) {
                    console.log('[RechargeFeedbackHelpDialog] first item structure:', this.paymentMethodsLocal[0]);
                    console.log('[RechargeFeedbackHelpDialog] first item rechargeNormList:', this.paymentMethodsLocal[0].rechargeNormList);
                }
                return this.paymentMethodsLocal;
            }
        }
    }
</script>
<style  scoped>
  .recharge-feedback-help-dialog-bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 1000;
    height: 0.88rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100vw;
    max-width: 100vw;
    box-sizing: border-box;
    padding: 0 0.18rem;
    background-color: #E8E4FF;
    border-radius: 0;
    box-shadow: 0 6px 16px rgba(16, 24, 40, 0.08);
    color: #222;
    font-size: 0.28rem;
    line-height: 1;
    padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 0.08rem);
  }

  .recharge-feedback-help-dialog-bottom .left {
    display: flex;
    align-items: center;
    gap: 0.12rem;
  }

  .rechargeIcon {
    width: 0.6rem;
    height: 0.6rem;
    flex: 0 0 0.6rem;
  }

  .rfhd-intro-text {
    background: #fff;
    padding: .2rem;
    margin-right: 1rem;
    border-radius: .2rem;
  }

  .label {
    color: #2b2b2b;
    font-size: 0.28rem;
    white-space: nowrap;
  }

  .closeIcon {
    width: 0.48rem;
    height: 0.48rem;
    cursor: pointer;
    opacity: 0.9;
  }
  /* modal 样式 */
  .rfhd-modal-overlay {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.32);
    display: flex;
    align-items: flex-end;
    padding-top: 0;
    justify-content: center;
    z-index: 2000;
  }
  .rfhd-modal {
    width: 100%;
    max-width: 720px;
    background: #F4F6F9;
    border-radius: 12px 12px 0 0;
    padding: 0;
    box-sizing: border-box;
  }
  .rfhd-modal-header {
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding-bottom:0.25rem;
    padding-top: .25rem;
    padding-left: 0.16rem;
    padding-right: 0.16rem;
    background: #fff;
    border-top-left-radius: 0.16rem;
    border-top-right-radius: 0.16rem;
  }
  .rfhd-modal-title-wrap {
    flex: 1;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    display: flex;
    justify-content: center;
    align-items: center;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .rfhd-modal-title-wrap::-webkit-scrollbar {
    display: none;
  }
  .rfhd-modal-title {
    font-weight: 600;
    font-size: 0.32rem;
    white-space: nowrap;
  }
  .rfhd-modal-close { width:0.48rem; height:0.48rem; cursor:pointer; }
  .rfhd-modal-body { padding-top:0.24rem; padding-bottom:0.24rem; }
  .rfhd-intro { display:flex; gap:0.18rem; align-items:flex-start; padding:0.18rem; border-radius:8px; }
  .rfhd-intro-icon { width:0.6rem; height:0.6rem; border-radius: 50%;  }
  .rfhd-intro-text { font-size:0.26rem; color:#666; line-height:1.4; }
  .rfhd-recommend-title { margin-top:0.28rem; color:#333; font-weight:500; font-size:0.28rem; padding-left: .32rem; margin-bottom: .24rem  }
  .rfhd-recommend-list { list-style:none; padding:0; margin:0.18rem 0 0 0; }
  .rfhd-recommend-item { display:flex; align-items:center; gap:0.18rem; padding:0.18rem 0; border-bottom:1px dashed #eee; }
  .rfhd-recommend-item img { width:1.6rem; height:auto; }
  .rfhd-modal-footer { display:flex; justify-content:center; padding-top:0.12rem;padding-bottom: .48rem; }
  .rfhd-feedback-btn { background:#6B5BFF; color:white; border-radius:22px; padding:0.18rem 1.4rem; border:none; font-size:0.28rem; }

  /* 支付方式样式 - 参考首页 */
  .payment-scroll-container {
    max-height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;
    /* 自定义滚动条样式 */
    scrollbar-width: thin;
    scrollbar-color: #ddd #f0f0f0;
  }

  .payment-scroll-container::-webkit-scrollbar {
    width: 4px;
  }

  .payment-scroll-container::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 2px;
  }

  .payment-scroll-container::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 2px;
  }

  .payment-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #ccc;
  }

  .payStyleCon {
    margin: 0.2rem 0;
  }

  .payStyleIcon {
    width: 0.8rem;
    height: 0.8rem;
    margin-right: 0.2rem;
    flex-shrink: 0;
  }

  .payStyleIcon img {
    width: 100%;
    height: 100%;
    border-radius: 0.1rem;
    object-fit: contain;
  }

  /* 确保van-collapse-item的title可以点击 */
  .van-collapse-item__title {
    padding: 0.2rem 0.32rem !important;
  }

  .van-collapse-item__content {
    padding: 0.2rem 0.32rem !important;
  }

  .payTiptxt {
    color: #999;
    font-size: 0.24rem;
    padding-top: 0.3rem;
    padding-bottom: 0.2rem;
  }

  .buyInfoItem {
    height: 1.3rem;
    display: flex;
    align-items: center;
    margin-top: 0.3rem;
    padding: 0 0.3rem;
    background-color: #F7F7F7;
    border-radius: 0.14rem;
  }

  .diamond_icon {
    width: 0.5rem;
    height: 0.5rem;
  }

  .buyNum {
    font-size: 0.38rem;
  }

  .morereward_txt {
    margin-left: 0.05rem;
    font-size: 0.3rem;
    color: #F94A8C;
  }

  .morereward_img {
    height: 0.34rem;
    margin-left: 0.1rem;
  }

  .payBtn {
    border-color: #999;
    color: #333;
    width: 1.76rem;
    font-size: 0.32rem;
  }

  /* 按钮基础样式 */
  .fc-btn-line-main {
    min-width: 1.8rem;
    padding: 0.22rem 0.3rem;
    line-height: 1;
    border: 1px solid #008AFF;
    text-align: center;
    border-radius: 1rem;
    font-size: 0.26rem;
    color: #008AFF;
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .fc-btn-line-main:hover {
    background: #008AFF;
    color: white;
  }

  .payBtn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  }

  .payBtn:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
  }

  .nodataImg {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 1rem 0;
  }

  .nodataImg img {
    width: 2rem;
    height: auto;
    opacity: 0.6;
  }

  /* 币商列表样式 */
  .sellers-content {
    margin: 0.2rem 0;
  }

  .fc-relative {
    position: relative;
  }

  .sellers-list-hidden {
    display: none;
  }

  .sellers-content .seller-item {
    padding: .3rem;
    background-color: #fff;
    margin-bottom: .2rem;
    border-radius: 0.1rem;
  }

  .sellers-content .seller-item:last-child {
    margin-bottom: 0;
  }

  .sellers-content .seller-item-head {
    display: flex;
    align-items: center;
  }

  .sellers-content .seller-photo {
    width: 1.1rem;
    height: 1.1rem;
    border-radius: 50%;
  }

  .seller-flag {
    position: absolute;
    width: 0.3rem;
    height: 0.3rem;
    right: 0;
    bottom: 0;
    border-radius: 50%;
    overflow: hidden;
    background-size: cover;
  }

  /* 阿拉伯语版本国旗位置调整 */
  .ar .seller-flag {
    right: inherit;
    left: 0;
  }

  .sellers-content .seller-info {
    flex: 1;
    align-items: center;
    margin-left: 0.24rem;
  }

  .sellers-content .seller-title-id {
    display: flex;
    justify-content: space-between;
  }

  .sellers-content .seller-title {
    font-size: 0.32rem;
    line-height: 1.1;
    font-weight: bold;
    word-break: break-word;
    max-width: 3.8rem;
  }

  .seller-ids {
    display: flex;
  }

  .seller-ids .seller-id {
    font-size: .26rem;
    color: #61636B;
    font-weight: 600;
    line-height: .32rem;
    margin: 0 .08rem;
  }

  .seller-ids .copy-btn {
    height: .32rem;
  }

  .sellers-content .seller-balance {
    margin-top: 0.14rem;
    display: flex;
    align-items: center;
    font-size: 0.26rem;
    color: #1F1F1F;
  }

  .sellers-content .seller-balance .balance-title {
    max-width: 3.4rem;
  }

  .sellers-content .seller-balance .balance-icon {
    width: 0.36rem;
    margin-left: 0.24rem;
  }

  .sellers-content .seller-balance .balance-num {
    font-size: 0.32rem;
    color: #008AFF;
  }

  .seller-paytypes {
    width: 7rem;
    margin-top: 0.24rem;
  }

  .seller-paytypes .paytypes-list {
    display: flex;
    width: 7.1rem;
    overflow-x: auto;
  }

  .seller-paytypes .paytype-box {
    flex: 0 0 1.26rem;
    height: 0.48rem;
    text-align: center;
    border: 1px solid #F2F2F2;
    border-radius: 0.04rem;
    margin-right: 0.08rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .seller-paytypes .paytype-box img {
    max-width: 1.26rem;
    max-height: 0.48rem;
  }

  .seller-paytypes .paytype-box:last-child {
    margin-right: 0.3rem;
  }

  .sellers-nodata {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0.5rem 0;
  }

  .sellers-nodata img {
    width: 1.5rem;
    opacity: 0.6;
  }

  .sellers-no-login {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1rem 0;
  }

  .no-login-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .no-login-content img {
    width: 2.5rem;
  }

  .login-tip {
    text-align: center;
    font-weight: bold;
    margin: 0.2rem 0;
  }

  /* 响应式设计 */
  @media (max-width: 375px) {
    .payment-scroll-container {
      max-height: 50vh;
    }

    .buyInfoItem {
      padding: 0.25rem 0;
    }

    .payBtn {
      padding: 0.12rem 0.3rem;
      font-size: 0.26rem;
    }

    .buyNum {
      font-size: 0.3rem;
    }
  }

  /* 平板设备 */
  @media (max-width: 768px) and (min-width: 376px) {
    .payment-scroll-container {
      max-height: 55vh;
  }
}

/* 弹窗上弹/下降动画 */
.modal-slide-enter-active,
.modal-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.modal-slide-enter,
.modal-slide-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.modal-slide-enter-to,
.modal-slide-leave {
  opacity: 1;
  transform: translateY(0);
}

/* overlay 遮罩渐变 */
.modal-slide-enter-active .rfhd-modal-overlay,
.modal-slide-leave-active .rfhd-modal-overlay {
  transition: opacity 0.3s ease;
}
.modal-slide-enter .rfhd-modal-overlay,
.modal-slide-leave-to .rfhd-modal-overlay {
  opacity: 0;
}
.modal-slide-enter-to .rfhd-modal-overlay,
.modal-slide-leave .rfhd-modal-overlay {
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/RechargeFeedbackHelpDialog.vue